import { Button } from "@egaranti/components";

import React from "react";
import { NavLink, useLocation } from "react-router-dom";

import useAppStore from "@/stores/useAppStore";
import useInboxStore from "@/stores/useInboxStore";

import { ExternalLink, Inbox, Menu } from "lucide-react";

import { getToken } from "@/lib/authStorage";
import { cn, getHeaderTitle } from "@/lib/utils";

const MainHeader = () => {
  const title = getHeaderTitle(useLocation().pathname);
  const { unReadCount, getUnreadInboxCount } = useInboxStore();
  const { setOpenMobileMenu } = useAppStore();
  const token = getToken();
  const location = useLocation();

  const isActive = (url) => {
    return location.pathname === url;
  };

  React.useEffect(() => {
    getUnreadInboxCount();
  }, []);

  return (
    <header className="sticky top-0 z-40 flex h-16 w-full flex-row items-center justify-between border-b border-[#e5e5e7]/60 bg-white/80 px-5 backdrop-blur-xl">
      <div className="flex items-center gap-3">
        {/* Mobile Menu Button */}
        <button
          onClick={() => setOpenMobileMenu(true)}
          aria-label="Menüyü aç"
          className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#f5f5f7] text-[#1d1d1f] transition-all hover:bg-[#e5e5e7] md:hidden"
        >
          <Menu size={20} strokeWidth={1.5} />
        </button>

        {/* Page Title */}
        <h2 className="text-[17px] font-semibold tracking-[-0.02em] text-[#1d1d1f]">
          {title}
        </h2>
      </div>

      <div className="flex items-center gap-3">
        {/* Service App Button — only render when target URL is configured. */}
        {import.meta.env.VITE_SERVICE_APP_URL && token && (
          <Button asChild>
            <a
              href={`${import.meta.env.VITE_SERVICE_APP_URL}/login/jwt?token=${token}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <ExternalLink size={14} strokeWidth={1.5} />
              <span className="hidden sm:inline">egaranti Service</span>
            </a>
          </Button>
        )}

        {/* Inbox Button */}
        <NavLink
          to="/inbox"
          aria-label="Gelen Kutusu"
          className={cn(
            "relative flex h-11 w-11 items-center justify-center rounded-xl transition-all",
            isActive("/inbox")
              ? "bg-[#0049E6] text-white shadow-sm"
              : "bg-[#f5f5f7] text-[#1d1d1f] hover:bg-[#e5e5e7]"
          )}
        >
          <Inbox size={20} strokeWidth={1.5} />
          {unReadCount > 0 && (
            <span className="absolute -right-1 -top-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#ff3b30] px-1 text-[10px] font-semibold text-white shadow-sm">
              {unReadCount > 99 ? "99+" : unReadCount}
            </span>
          )}
        </NavLink>
      </div>
    </header>
  );
};

export default MainHeader;
